import { makeStyles } from '@material-ui/core/styles';

const noSubscribedStyle = makeStyles((theme) => ({
  howGetPoints: {
    fontSize: 16,
    textAlign: 'center',
    color: '#666666',
  },
  acceptTerms: {
    textAlign: 'left',
    fontSize: 14,
    '& a': {
      color: '#6A148E',
    },
  },
  purpleLink: {
    color: '#6A148E',
  },
  redLink: {
    color: '#EB0043',
    textAlign: 'left',
    '& a': {
      color: '#EB0043',
    },
    fontSize: 14,
  },
  points: {
    fontSize: 50,
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  imgRPGO: {
    width: 136,
  },
  button: {
    marginTop: 20,
  },
  noSubscribedSBody: {
    marginTop: 46,
  },
  tabPanelTitle: {
    color: '#1A1A1A',
    lineHeight: 1,
    fontSize: 20,
    fontWeight: 600,
    textAlign: 'center',
    marginTop: 20,
  },
  tabPanelSubtitle: {
    textAlign: 'center',
    fontSize: 16,
    letterSpacing: 0,
    color: '#666666',
    opacity: 1,
    width: '80%',
    margin: 'auto',
    marginTop: 20,
  },
  accumulateOptions: {
    marginTop: 20,
    fontSize: 16,
    color: '#666666',
  },
  dateValid: {
    color: '#464646',
    fontSize: 12,
    opacity: 1,
  },
  iconTextDescription: {
    display: 'grid',
    gridTemplateColumns: '0.2fr 1.7fr',
    gap: 20,
  },
  divThreeGridTitle: {
    color: '#464646',
    fontSize: 16,
    fontWeight: 600,
    display: 'grid',
    gridTemplateColumns: '0.4fr 0.9fr 0.9fr',
    gap: '0 30px',
    border: 0,
    borderBottom: '1px solid #ccc',
    margin: '1.5em 0',
    padding: 0,
    gridColumnStart: 1,
    gridColumnEnd: 4,
    textAlign: 'center',
  },
  divThreeGrid: {
    fontSize: 16,
    fontWeight: 600,
    display: (props) => (props.mobile ? '' : 'grid'),
    gridTemplateColumns: (props) => (props.mobile ? '' : '0.4fr 0.9fr 0.9fr'),
    gap: (props) => (props.mobile ? '' : '0 30px'),
    border: 0,
    borderBottom: '1px solid #ccc',
    margin: '1.5em 0',
    padding: 0,
    gridColumnStart: 1,
    gridColumnEnd: 4,
    textAlign: 'center',
  },
  rpgoImage: {
    height: 50,
    verticalAlign: 'middle',
    marginTop: -6,
  },
  divStar: {
    borderBottom: '1px solid #ccc',
  },
  starContainer: {
    paddingTop: 10,
    color: '#666666',
    lineHeight: (props) => (props.mobile ? '' : 0.5),
    marginBottom: 40,
  },
  gridOneStar: {
    fontSize: 16,
    display: (props) => (props.mobile ? '' : 'grid'),
    gridTemplateColumns: (props) => (props.mobile ? '' : '0.35fr 0.85fr 0.1fr'),
    gap: (props) => (props.mobile ? '' : '0 30px'),
    marginTop: 40,
    marginBottom: 25,
  },
  gridTerm: {
    color: '#464646',
    '& a': {
      color: '#464646',
    },
  },
  gridTermRight: {
    textAlign: 'right',
  },
  gridTermLeft: {
    textAlign: 'left',
  },
  acceptTermsText: {
    marginTop: 1,
  },
  checkboxError: {
    '& svg': {
      color: '#EB0043',
    },
  },
  divFourGridTitle: {
    color: '#464646',
    fontSize: (props) => (props.mobile ? 12 : 16),
    fontWeight: 600,
    display: 'grid',
    gridTemplateColumns: (props) =>
      props.mobile ? '0.7fr 0.4fr 0.4fr 0.6fr' : '0.5fr 0.5fr 0.4fr 0.6fr',
    gap: '0 30px',
    border: 0,
    borderBottom: '1px solid #ccc',
    margin: '1.5em 0',
    padding: 0,
    gridColumnStart: 1,
    gridColumnEnd: 4,
    textAlign: 'center',
  },
  divFourGrid: {
    fontSize: (props) => (props.mobile ? 12 : 16),
    fontWeight: 600,
    display: 'grid',
    gridTemplateColumns: '0.5fr 0.5fr 0.4fr 0.6fr',
    gap: '0 30px',
    border: 0,
    borderBottom: '1px solid #ccc',
    margin: '1.5em 0',
    padding: 0,
    gridColumnStart: 1,
    gridColumnEnd: 4,
    textAlign: 'center',
  },
  circle: {
    width: (props) => (props.mobile ? 36 : 48),
    height: (props) => (props.mobile ? 36 : 48),
    borderRadius: (props) => (props.mobile ? 18 : 24),
    lineHeight: (props) => (props.mobile ? '36px' : '48px'),
    color: 'white',
    margin: 'auto',
    marginBottom: (props) => (props.mobile ? 10 : 30),
    marginTop: (props) => (props.mobile ? '' : 10),
  },
  circleContainer: {
    width: '100%',
  },
  boxCategories: {
    display: 'grid',
    gridTemplateColumns: (props) => (props.mobile ? '' : '45% 45%'),
    direction: (props) => (props.mobile ? 'column' : ''),
    justifyContent: 'space-between',
    marginBottom: 45,
    marginTop: 40,
    rowGap: (props) => (props.mobile ? '20px' : ''),
  },
}));

export default noSubscribedStyle;
